export function authHeaders() {
  const headers = new Headers();
  headers.append("X-CSRF-Token", document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
  headers.append('X-Requested-With', 'XMLHttpRequest');
  return headers
}
